export default {
    methods: {
        clearMessages: function () {
            this.$root.$helper.messages.removeToast();
        },
        showHttpError: function (error) {
            this.$root.$helper.error.httpError(error);
            if (this.$root.$env.DEBUG) {
                console.error(error);
            }
        },
        showInfo: function (message, title = this.pageTitle, callbackClose = () => {}, timeout = 5000) {
            this.showMessage(message, title, 'info', callbackClose, timeout);
        },
        showWarning: function (message, title = this.pageTitle, callbackClose = () => {}, timeout = 5000) {
            this.showMessage(message, title, 'warning', callbackClose, timeout);
        },
        showError: function (message, title = this.pageTitle, callbackClose = () => {}, timeout = 5000) {
            this.showMessage(message, title, 'error', callbackClose, timeout);
        },
        showMessage: function (message, title = this.pageTitle, type = 'success', callbackClose = () => {}, timeout = 5000) {
            this.$root.$helper.messages.showToast(this.$t(message), this.$t(title), type, callbackClose, timeout);
        },
    }
};
